import { BASE_URL } from "../constant/constant";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface VerifyTwoFATokenRequest {
  token: string;
  email: string;
  persona?: string;
}

const verifyTwoFAToken = async ({
  token,
  email,
  persona,
}: VerifyTwoFATokenRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/auth/verify-two-factor-token`,
      { token, email, persona },
      { withCredentials: true }
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default verifyTwoFAToken;
